import React, { useState, useContext, useEffect } from 'react'
import Swal from 'sweetalert2'
import moment from 'moment'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

import { format, parseISO } from 'date-fns'
import { sendSolicitation, updateSolicitation } from '../../services/solicitations'
import { SOLICITATION_CATEGORY } from '../../utils/constants'
import { Textarea } from '../../components/Form'

import { RootContext } from '../../context/rootContext'
import chatProcessingIcon from '../../assets/icons/chat-processing.svg'
import blockIcon from '../../assets/icons/block-duotone.svg'
import {
  Container,
  Header,
  BlockTime,
  NotificationCircle,
  Body,
  Item,
  Icon,
  Description,
  QuestionContent,
  Question,
  PendingAnswer,
  TextAreaContent,
  MaxCaracters,
  ButtonSubmit,
  Footer,
  ButtonOpen
} from './styles'

const Block = ({
  item: {
    date,
    end,
    id,
    solicitation: {
      id: solicitationId,
      answerMessage,
      questionMessage,
      answerRead,
      kind
    }
  }
}) => {
  const [open, setOpen] = useState(false)
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [questionLabelMessage, setQuestionLabelMessage] = useState(questionMessage)
  const [newQuestionMessage, setNewQuestionMessage] = useState('')
  const [newAnswerMessage, setNewAnswerMessage] = useState(answerMessage)
  const [notificationRead, setNotificationRead] = useState(answerRead)
  const timeStart = format(parseISO(date), 'HH:mm')
  const timeEnd = format(parseISO(end), 'HH:mm')
  const { handleUpdateSolicitation } = useContext(RootContext)

  useEffect(() => {
    setQuestionLabelMessage(questionMessage)
  }, [questionMessage])

  useEffect(() => {
    setNewAnswerMessage(answerMessage)
  }, [answerMessage])

  useEffect(() => {
    setNotificationRead(answerRead)
  }, [answerRead])

  const handleOpen = async () => {
    setOpen(!open)

    if (solicitationId && !notificationRead && newAnswerMessage) {
      const response = await updateSolicitation(solicitationId, {
        answerRead: true,
        kind
      })

      const responseData = response.data
      if (responseData) {
        setNotificationRead(responseData.answerRead)
        handleUpdateSolicitation(solicitationId, responseData)
      } else {
        Swal.fire({
          title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
          html: '<p style="color: #000;">Não foi possível enviar sua solicitação, tente novamente</p>',
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          background: '#fff'
        })
      }
    }
  }

  const handleSetNewQuestionMessage = (e) => {
    const newQuestionMessage = e.target.value
    setNewQuestionMessage(newQuestionMessage)
  }

  const handleSubmitSolicitation = async () => {
    setIsSubmitLoading(true)

    const { professional } = JSON.parse(localStorage.getItem('userData'))
    const response = await sendSolicitation({
      professionalId: professional.id,
      referenceId: id,
      kind: SOLICITATION_CATEGORY.AGENDA_BLOCK_UPDATE,
      questionMessage: newQuestionMessage,
      solicitation: {
        start: moment(date).utc(),
        end: moment(end).utc()
      }
    })

    const responseData = response.data
    if (responseData) {
      setNewAnswerMessage(responseData.answerMessage)
      setQuestionLabelMessage(responseData.questionMessage)
      setNewQuestionMessage('')
      handleUpdateSolicitation(solicitationId, responseData)
    } else {
      Swal.fire({
        title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
        html: '<p style="color: #000;">Não foi possível enviar sua solicitação, tente novamente</p>',
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        background: '#fff'
      })
    }
    setIsSubmitLoading(false)
  }

  return (
    <Container>
      <Header>
        <BlockTime>{timeStart}-{timeEnd}</BlockTime>
        { !notificationRead && answerMessage && (
          <NotificationCircle>1</NotificationCircle>
        )}
      </Header>
      <Body open={open}>
        <Item>
          <Icon>
            <img src={blockIcon} alt="bloqueio" />
          </Icon>
          <Description>Bloqueio de agenda</Description>
        </Item>
        { questionLabelMessage && (
          <QuestionContent>
            <Icon>
              <img src={chatProcessingIcon} alt="conversa" />
            </Icon>
            <div className='flex-column'>
              <Question>{questionLabelMessage}</Question>
              { !newAnswerMessage && (
                <PendingAnswer>Resposta pendente</PendingAnswer>
              )}
              { newAnswerMessage && (
                <PendingAnswer>- {newAnswerMessage}</PendingAnswer>
              )}
            </div>
          </QuestionContent>
        )}
        <TextAreaContent>
          <Textarea
            label='Solicitação para recepção (obrigatório)'
            name='AgendaBlockMessage'
            placeholder='Escreva aqui sua resposta'
            maxLength={140}
            value={newQuestionMessage}
            onChange={handleSetNewQuestionMessage}
          />
          <MaxCaracters>{newQuestionMessage.length}/140</MaxCaracters>
        </TextAreaContent>
        <ButtonSubmit onClick={handleSubmitSolicitation} disabled={isSubmitLoading || newQuestionMessage === ''}>
          Solicitar alteração
        </ButtonSubmit>
      </Body>
      <Footer>
        <ButtonOpen onClick={handleOpen}>
          {open ? (<FaChevronUp size='21' color='#555' />) : (<FaChevronDown size='21' color='#555' />)}
        </ButtonOpen>
      </Footer>
    </Container>
  )
}

export default Block
